import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'patientName',
  standalone: true,
  pure: true
})
export class PatientNamePipe implements PipeTransform {

  transform(nameData: any[] | string | undefined | null): string {
    if (!nameData) return 'Unknown Patient';

    // If it's already a string, return it (or optionally format it)
    if (typeof nameData === 'string') {
      return nameData.trim() || 'Unknown Patient';
    }

    // If it's an array, use existing logic
    if (Array.isArray(nameData) && nameData.length > 0) {
      const name = nameData.find((n: any) => n.use === 'official' || n.use === 'usual') || nameData[0];

      const parts: string[] = [];

      if (name.given && Array.isArray(name.given) && name.given.length > 0) {
        const givenNames = name.given.filter((g: string) => g && g.trim()).join(' ');
        if (givenNames) parts.push(givenNames);
      }

      if (name.family && name.family.trim()) {
        parts.push(name.family);
      }

      return parts.join(' ').trim() || 'Unknown Patient';
    }

    // Fallback
    return 'Unknown Patient';
  }
}
